import React from 'react';
import * as XLSX from 'xlsx';
import { BottomNavigationAction } from '@material-ui/core';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

function ExcelExport({ JsonData }) {
  if (JsonData?.length === 0) {
    return (
      <BottomNavigationAction
        disabled={true}
        showLabel
        label={'Excel Al'}
        icon={<CloudDownloadIcon />}
      />
    );
  }

  const handleExport = () => {
    const ExportData = JsonData.map((item) => ({
      MALZEME_STOK_NO: item.MALZEME_STOK_NO,
      MALZEME: item.MALZEME,
      SINIF: item.SINIF,
      FIYAT: item.FIYAT,
      DEPO_ADI: item.DEPO_ADI,
      ADRES: item.ADRES,
      TOPLAM_MEVCUT_ADET: item.TOPLAM_MEVCUT_ADET,
      KULLANILABILIR_ADET: item.KULLANILABILIR_ADET,
      TEKNISYEN_ZIMMET_ADET: item.TEKNISYEN_ZIMMET_ADET,
      GIRIS_ADET: item.GIRIS_ADET,
      CIKIS_ADET: item.CIKIS_ADET,
    }));

    // Başlıklar (label) ve veriler (value)
    const headers = [
      { label: 'MalzemeStokNo', value: 'MALZEME_STOK_NO' },
      { label: 'Malzeme', value: 'MALZEME' },
      { label: 'Sınıf', value: 'SINIF' },
      { label: 'Fiyat', value: 'FIYAT' },
      { label: 'Depo Adı', value: 'DEPO_ADI' },
      { label: 'Adres', value: 'ADRES' },
      { label: 'DepoAdet', value: 'KULLANILABILIR_ADET' },
      { label: 'TeknisyenZimmet', value: 'TEKNISYEN_ZIMMET_ADET' },
      { label: 'Toplam', value: 'TOPLAM_MEVCUT_ADET' },
    ];

    // Başlıkları içeren bir array oluşturuyoruz
    const sheetData = [headers.map(header => header.label), ...ExportData.map(item => headers.map(header => item[header.value]))];

    // Excel dosyasını oluşturma
    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Envanter');

    // Excel dosyasını indirme
    XLSX.writeFile(workbook, 'Envanter.xlsx');
  };

  return (
    <BottomNavigationAction
      onClick={handleExport}
      showLabel
      label={'Excel'}
      icon={<CloudDownloadIcon />}
    />
  );
}

export default ExcelExport;
